<template>
<v-app>
  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
        class="wizard wizard-2"
        id="kt_wizard_v2"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav -->
        <div class="wizard-nav border-right py-8 px-8 py-lg-20 px-lg-10">
          <div class="wizard-steps">
            <div
              class="wizard-step"
              data-wizard-type="step"
              data-wizard-state="current"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/General/User.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información de la empresa
                  </h3>
                  <div class="wizard-desc">
                    Empresa asociada a la cuenta
                  </div>
                </div>
              </div>
            </div>
            <div
              class="wizard-step"
              data-wizard-type="step"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/General/User.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información del Usuario
                  </h3>
                  <div class="wizard-desc">
                    Configure datos personales
                  </div>
                </div>
              </div>
            </div>

            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/Map/Compass.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información de Seguridad
                  </h3>
                  <div class="wizard-desc">
                    Configure credenciales
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body -->
        <div class="wizard-body py-8 px-8 py-lg-20 px-lg-10">
          <!--begin: Wizard Form-->
          <div class="row">
            <div class="offset-xxl-2 col-xxl-8">
              <b-form class="form" @submit.stop.prevent="onSubmit">
                <!--begin: Wizard Step 1-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Ingrese los datos la empresa
                  </h4>
                  <div class="form-group">
                      <div class="form-group">
                        <label>Empresa</label>
                      {{client.empresa.nombre}}
                      </div>
                    </div>
                    <button
                      class="btn btn-primary align-self-center"
                      data-wizard-type="action-next"
                    >
                      Continuar
                    </button>
                </div>
                <!--end: Wizard Step 1-->
                <!--begin: Wizard Step 2-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Ingrese los datos personales
                  </h4>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Rut Cliente</label>
                        {{rutCliente}}
                      </div>
                    </div>
                    <div class="col-xl-6">
                      
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Nombres</label>
                    <b-form-input
                      class="form-control"
                      type="text"
                      id="example-input-3"
                      name="example-input-3"
                      v-model="$v.form.nombres.$model"
                      :state="validateState('nombres')"
                      aria-describedby="input-3-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="input-3-live-feedback">
                      Nombre es requerido.
                    </b-form-invalid-feedback>
                  </div>
                  <div class="form-group">
                    <label>Apellidos</label>
                    <b-form-input
                      class="form-control"
                      type="text"
                      id="example-input-4"
                      name="example-input-4"
                      v-model="$v.form.apellidos.$model"
                      :state="validateState('apellidos')"
                      aria-describedby="input-4-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="input-4-live-feedback">
                      Apellidos es requerido.
                    </b-form-invalid-feedback>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Teléfono</label>
                        <b-form-input
                          class="form-control"
                          type="tel"
                          id="telefono"
                          name="telefono"
                          v-model="$v.form.telefono.$model"
                          :state="validateState('telefono')"
                          aria-describedby="input-telefono-feedback"
                        ></b-form-input>

                        <b-form-invalid-feedback id="input-telefono-feedback">
                          Teléfono es requerido.
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Email</label>
                        <b-form-input
                        class="form-control"
                        type="email"
                        id="example-input-5"
                        name="example-input-5"
                        v-model="$v.form.email.$model"
                        :state="validateState('email')"
                        aria-describedby="input-5-live-feedback"
                      ></b-form-input>

                      <b-form-invalid-feedback id="input-5-live-feedback">
                        Email es requerido.
                      </b-form-invalid-feedback>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <label>Cuenta Activada</label>
                         <v-switch v-model="switch1"></v-switch>
                        
                      </div>
                    </div>
                    <div class="col-xl-6">
                      
                    </div>
                  </div>
                  <button 
                      class="btn btn-primary align-self-center"
                      type="submit"
                    >
                      Actualizar
                    </button>
                   
                </div>
                <!--end: Wizard Step 2-->

                <!--begin: Wizard Step 3-->
                <div class="pb-5" data-wizard-type="step-content">
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Configure Información de Acceso
                  </h4>
                  <div class="row">
                     <div class="col-xl-12">
                       <div class="alert alert-info">
                         Puedes crear una nueva contraseña. Será enviada al usuario.
                       </div>
                     </div>
                   

                  </div>
                  
                  <button 
                      class="btn btn-primary align-self-center"
                      type="button" v-on:click="resetClientPassword()"
                    >
                      Enviar nueva contraseña
                    </button>
                </div>
                <!--end: Wizard Step 3-->

                

               
              </b-form>
            </div>
            <!--end: Wizard-->
          </div>
        </div>
        <!--end: Wizard Body -->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
</v-app>
</template>
<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
</style>
<style>
.transparent {
  background: transparent !important;
}
.perfil-menu {
  background: #fff;
}
.perfil-body {
  background: #fff;
}
</style>

<script>
import { mapState } from "vuex";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import { validationMixin } from "vuelidate";
import { GET_COMPANIES } from "@/core/services/store/company.module";
import { GET_CLIENT, UPDATE_CLIENT, RESET_CLIENT_PASSWORD } from "@/core/services/store/client.module";
import {
  email,
  required,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  name: "edicionCliente",
  data() {
    return {
      isMounted : false,
      wizard:null,
      switch1: true,
      step:1,
       form: {
        rutEmpresa: "",
        rutCliente:"",
        nombres:"",
        apellidos:"",
        telefono:null,
        email:"",
        passwordConfirm: "",
        password: "",
        activo:true
      },
      };
  },
  validations: {
    form: {
      nombres: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(75)
      },
      apellidos: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(75)
      },
      email: {
        required,
        email,
        maxLength: maxLength(75)
      },
      telefono: {
        required
      }
    }
  },
  methods: {
    makeToast(append = false) {
      this.$bvToast.toast(`Hemos enviado la bienvenida y contraseña de acceso al cliente.`, {
        title: 'Cliente creado exitosamente',
        autoHideDelay: 5000,
        variant: "success",
        toaster:"b-toaster-top-right",
        appendToast: append
      })
    },
      mensajeClienteActualizado(append = false) {
      this.$bvToast.toast(`Se ha actualizado el cliente correctamente`, {
        title: 'Cliente actualizado exitosamente',
        autoHideDelay: 5000,
        variant: "success",
        toaster:"b-toaster-top-right",
        appendToast: append
      })
    },
    getCompanies(params = null) {
      this.$Progress.start();
      this.$store
          .dispatch(GET_COMPANIES, params)
          .then(()=>{
            this.$Progress.finish()});
    },
    resetClientPassword() {
      this.$Progress.start();
      this.$store
          .dispatch(RESET_CLIENT_PASSWORD, this.client.tokenCliente)
          .then(() => this.$Progress.finish(),this.makeToast());
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.actualizarCuenta();
    },
    actualizarCuenta(){
      const tokenUsuario = this.client.tokenCliente;
      const rutEmpresa = this.client.rutEmpresa;
      const numeroDocumento = '';
      const rutCliente = this.client.rutCliente;
      const nombres = this.$v.form.nombres.$model;
      const apellidos = this.$v.form.apellidos.$model;
      const email = this.$v.form.email.$model;
      const telefono = parseInt(this.$v.form.telefono.$model);
      //const password = this.$v.formFull.password.$model;
      //const passwordConfirm = this.$v.formFull.passwordConfirm.$model;
      // set spinner to submit button
      //const submitButton = this.$refs["kt_register_signin_submit"];
      //submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(UPDATE_CLIENT, { tokenUsuario, rutEmpresa, numeroDocumento, rutCliente, nombres, apellidos, email, telefono, activo:this.switch1 })
          // go to which page after successfully login
          .then(() => this.mensajeClienteActualizado());

        /*submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );*/
      }, 500);
    },
    getClient() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_CLIENT, this.$route.params.token)
          .then((response)=>{
            this.$v.form.email.$model = `${response.email}`,
          this.$v.form.nombres.$model = response.nombres,
          this.$v.form.apellidos.$model = response.apellidos,
          this.$v.form.telefono.$model = response.telefono,
             this.switch1 = this.response.activo

            this.$Progress.finish()});
    },
  },
  beforeUpdate() {
      if(!this.isMounted){
        console.log("actualizado " + JSON.stringify(this.client));
        this.$nextTick(function() {
          console.log("nextTick", JSON.stringify(this.client));
          this.$v.form.email.$model = this.client.email;
          this.$v.form.nombres.$model = this.client.nombres;
          this.$v.form.apellidos.$model = this.client.apellidos;
          this.$v.form.telefono.$model = this.client.telefono;
          this.switch1 = this.client.activo
        });
        this.isMounted = true;
      }
  },
  mounted() {
    this.getClient();
    this.getCompanies();
    

    // Initialize form wizard
    this.wizard = new KTWizard("kt_wizard_v2", {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    // Validation before going to next page
    this.wizard.on("beforeNext", function(/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    this.wizard.on("change", function(/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors,
      client: state => state.client.client,
      companies: state => state.company.companies,
      rutCliente: function(){
        return `${this.client.rutCliente}-${this.client.dvCliente}`;
      },
    })
  }
};
</script>